import {
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Alertfill } from '../assets/Alertfill';

const animationError = keyframes`
    from {
        opacity:1;
    }
    to {
        opacity: 0;
    }
        `;

const Styles = styled.div`
  z-index: 999;
  direction: rtl;
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column-reverse;
  width: 25rem;
  font-size: 16px;
  
  .error {
    --text-color-error: #D33535;
    --bg-color-error: #D3353570;
    /* animation: 5s ${animationError} ease-in; */
    /* --webkit-animation: 5s ${animationError} ease-in; */
    background-color: var(--bg-color-error);
    border: 1px solid var(--text-color-error);
    color: var(--text-color-error);
    backdrop-filter: blur(15px);
    margin: 1rem;
    padding: 1.3rem 1rem;
    display: flex;
    align-items: center;
    gap: 0.7rem;
    position: relative;
    border-radius: var(--border-radius-4);
    /* .action {
            position: absolute;
            top: 0.5rem;
            right: 0.7rem;
        } */
    .icon {
      /* margin: 0 1rem; */
      width: 32px;
      svg {
        fill: var(--text-color-error);
      }
    }
    .devider-error {
      width: 1px;
      background-color: var(--text-color-error);
      height: 32px;
    }
    .message {
      text-align: right;
      white-space: pre-line;
    }
  }
  .red {
    --text-color-error: #D33535;
    --bg-color-error: #D3353520;
  }
  .yellow {
    --text-color-error: #D7702D;
    --bg-color-error: #D7702D20;
  }
  .green {
    --text-color-error: #5B9D60;
    --bg-color-error: #5B9D6020;
  }
  .blue {
    --text-color-error: #0382A0;
    --bg-color-error: #0382A020;
  }
  @media screen and (max-width:840px){
    width: 80%;
    bottom: 4rem;
    right: 10px;
    .error{
      margin: 0.5rem 0;
      /* padding-right: 0; */
      /* align-items: baseline; */
    }
  }
`

class StakcableError extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [
        // {
        //   message: "ابتدا وارد حساب کاربری شوید!",
        //   // time: newTime.getTime() + time,
        //   color: "red",
        // },
        // {
        //   message: "ابتدا وارد حساب کاربری شوید!",
        //   // time: newTime.getTime() + time,
        //   color: "blue",
        // },
        // {
        //   message: "ابتدا وارد حساب کاربری شوید!",
        //   // time: newTime.getTime() + time,
        //   color: "green",
        // },{
        //   message: "ابتدا وارد حساب کاربری شوید!",
        //   // time: newTime.getTime() + time,
        //   color: "yellow",
        // }
      ],
    };
  }
  componentDidMount() {
    insertError = this.insertError.bind(this);
    this.interval();
  }
  insertError (msg, color, time) {
    let newTime = new Date();
    let errors = this.state.errors;
    if (typeof msg === 'object') {
      let keys = Object.keys(msg);
      keys.forEach((value) => {
        let value1 = msg[value];
        value1.forEach((value2) => {
          errors.push({
            message: value2,
            time: newTime.getTime() + time,
            color: color,
          });
        });
        this.setState({
          errors: errors,
        });
      });
    } else {
      errors.push({
        message: msg,
        time: newTime.getTime() + time,
        color: color,
      });
      this.setState({
        errors: errors,
      });
    }
  };
  interval = () => {
    setInterval(() => {
      let newTime = new Date();
      let errors = this.state.errors;
      errors.forEach((value, index) => {
        if (value.time < newTime.getTime()){
          this.deleteMsg(index);
        }
      });
    }, 1000);
  };
  deleteMsg = (key) => {
    let errors = this.state.errors;
    errors.splice(key, 1);
    this.setState({
      errors: errors,
    });
  };
  makeErrors = () => {
    let messages = this.state.errors.map((value, index) => {
      return (
        <div className={'error ' + value.color} key={index}>
          {/* <div className="action" onClick={() => this.deleteMsg(index)}>
                        <FontAwesomeIcon icon={faTimes}/>
                    </div> */}
          <div className="icon">
            <Alertfill/>
          </div>
          <div className='devider-error'></div>
          <div className="message small-text">{value.message}</div>
        </div>
      );
    });
    return messages;
  };
  render() {
    return <Styles>{this.makeErrors()}</Styles>;
  }
}
export var insertError;
// export function insertError(msg, color, time) {
//   this.insertError(msg, color, time)
// }
export default StakcableError;
